import DefaultSuggestedActionsEmptyState from './DefaultSuggestedActionsEmptyState.component';

export default DefaultSuggestedActionsEmptyState;
